<script>
    import ModalTitle from "../Modal/ModalTitle.svelte";
    import ModalButtons from "../Modal/ModalButtons.svelte";
    import WPNCreateItem from "./WPNCreateItem.svelte";
    import EditWorkSummary from "./EditWorkSummary.svelte";
    import EditLocation from "./EditLocation.svelte";
    import EditWorkPersonnel from "./EditWorkPersonnel.svelte";
    import EditRelatedItems from "./EditRelatedItems.svelte";
    import EditNotes from "./EditNotes.svelte";
    import { createEventDispatcher } from "svelte";
    import EditWorkMaterials from "./EditWorkMaterials.svelte";

    const dispatch = createEventDispatcher();
    export let createGroup = null;
    export let selectedItem = null;
    let entity;
    //  EDIT_TODO: Where is this used?
    // let mapImage;

    $: entity = selectedItem != null ? selectedItem["entity"] : "";
    $: isWork = entity == "WorkOrder" || entity == "Issue";
    $: mapImage = imageForMapItem(selectedItem);

    function createNewItem(event) {
        selectedItem = event.detail.createdItem;
        console.log("Will create: ", selectedItem);
        createGroup = null;
    }

    function removeItem(event) {
        console.log(event.detail);
    }

    function showAddBrowser(event) {
        console.log(event.detail);
    }

    function imageForMapItem(item) {
        if (item == null) {
            // EDIT_TODO: Continue here... Server: Handle getting a map image
            return null;
        }
        return null;
    }

    function saveItem() {
        if (selectedItem != null) {
        }
        dispatch("save");
    }
    // EDIT_TODO: Server: Handle save of an edited item
    // A date picker: https://github.com/6eDesign/svelte-calendar
    // Flat Picker: https://flatpickr.js.org  (install with npm)
</script>

{#if createGroup != null || selectedItem != null}
    {#if createGroup != null}
        <ModalTitle title="Creating" on:close />
        <WPNCreateItem {createGroup} on:will-create={createNewItem} />
        <ModalButtons
            actions={["cancel"]}
            on:cancel={() => dispatch("close")}
        />
    {:else if selectedItem != null}
        <div class="edit-item-container">
            <ModalTitle title="Editing" on:close />
            {#if isWork == true}
                <EditWorkSummary {selectedItem} />
            {/if}
            <EditLocation {selectedItem} />
            {#if isWork == true}
                <EditWorkPersonnel {selectedItem} />
                <EditWorkMaterials {selectedItem} />
            {/if}
            <EditRelatedItems {selectedItem} />
            <EditNotes {selectedItem} />
            <ModalButtons
                actions={["cancel", "save"]}
                on:cancel={() => dispatch("close")}
                on:save={saveItem}
            />
        </div>
    {/if}
{/if}

<style>
    .edit-item-container {
        height: 84vh;
        overflow: scroll;
    }
    :global(.edit-container) {
        padding: 16px;
    }
    :global(.edit-section-title) {
        color: #0a6ebd;
        font-size: 1rem;
        font-weight: 400;
        padding: 10px 0;
    }
    :global(.edit-form-inline) {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
    }
    :global(.edit-col) {
        padding: 0 16px;
        width: 256px;
    }
    :global(.edit-input) {
        width: 90%;
    }
    :global(.edit-label) {
        padding: 6px 4px;
        font-weight: 300;
        font-size: 13px;
    }
    :global(.add-button-view) {
        margin: 0.5rem;
    }
    :global(.edit-add-button) {
        background-color: rgb(67, 148, 11);
        color: white;
        border-radius: 5px;
        cursor: pointer;
        margin: 0.25rem 0.5rem;
        padding: 0.5rem 1rem;
    }
</style>
